import _ from "lodash";
import {uuid} from "vue-uuid";
import {isDefined} from "@/helper/Value";
import {isPost, isPre} from "@/helper/characteristic/Separation";

export function isEnabled({ groupByLetter, characteristic })
{
	if (!groupByLetter?.enabled)
	{
		return false;
	}

	let enabled = true;

	if (groupByLetter.condition)
	{
		if (characteristic && groupByLetter.condition.characteristicHasNotLabel)
		{
			enabled = enabled && characteristic.label !== groupByLetter.condition.characteristicHasNotLabel;
		}
	}

	return enabled;
}

export function group({items})
{
	let groups = [];

	const itemsWithSort = _.filter(items, item => isDefined(item.sort));
	const itemsWithoutSort = _.filter(items, item => !isDefined(item.sort));

	groups = _.concat(groups, buildGroups(itemsWithSort));
	groups = _.concat(groups, buildGroups(itemsWithoutSort));

	return groups;
}

function buildGroups(items)
{
	let groups = [];

	let currentGroup;

	_.forEach(items, characteristic =>
	{
		if (!currentGroup || isPre(characteristic.separation))
		{
			currentGroup = {
				id: uuid.v4(),
				separation: characteristic.separation,
				items: {}
			};

			groups.push(currentGroup);
		}

		const letter = characteristic.label
			.substring(0, 1)
			.toUpperCase();

		if (!currentGroup.items[letter])
		{
			currentGroup.items[letter] = [];
		}

		currentGroup.items[letter].push(characteristic);

		if (isPost(characteristic.separation))
		{
			currentGroup = {
				id: uuid.v4(),
				separation: characteristic.separation,
				items: {}
			};

			groups.push(currentGroup);
		}
	});

	return groups;
}
